import { Button } from "~/common/components";
import { BUTTON_VARIANTS } from "~/common/constants";
import { CHECK_IN_CODES } from "~/common/utils/types/checkInTypes";
import { SelectedPatientCheckin } from "../components";
import {
  CheckInSubmittedFeed,
  SELECTED_PATIENT_CHECKIN_TYPE,
} from "./types/patientFeeds";

export const getCheckinSubmittedTitle = (feed: CheckInSubmittedFeed): string =>
  feed.context.checkin_code === CHECK_IN_CODES.schedule_appointment
    ? `Appointment scheduled (${feed.context.data.extra_data?.duration})`
    : "Submitted";

export const getCheckinSubmittedAction = (
  feed: CheckInSubmittedFeed,
  viewPatientCheckInDetails: (
    selectedPatientCheckinInfo: SelectedPatientCheckin,
  ) => void,
) => {
  if (feed.context.checkin_code === CHECK_IN_CODES.schedule_appointment)
    return undefined;

  return (
    <Button
      variant={BUTTON_VARIANTS.outline_none}
      className="w-fit p-0 text-primary-600"
      onClick={() =>
        viewPatientCheckInDetails({
          feed,
          isProviderOrdered: false,
          type: SELECTED_PATIENT_CHECKIN_TYPE.regular,
        })
      }
    >
      See details
    </Button>
  );
};
